import { useLang } from '@/i18n';
import styles from './LangToggle.module.css';

// Kleiner DE/EN-Switch — als Pill mit zwei Segmenten. Das aktive Segment
// ist filled (Charcoal/Off-White), das inaktive outline-only. Klick auf
// inaktives Segment wechselt die Sprache.
export function LangToggle() {
  const { lang, setLang, t } = useLang();
  return (
    <div className={styles.wrap} role="group" aria-label={t('lang_toggle_aria')}>
      <button
        type="button"
        className={`${styles.seg} ${lang === 'de' ? styles.active : ''}`}
        aria-pressed={lang === 'de'}
        onClick={() => setLang('de')}
      >
        DE
      </button>
      <button
        type="button"
        className={`${styles.seg} ${lang === 'en' ? styles.active : ''}`}
        aria-pressed={lang === 'en'}
        onClick={() => setLang('en')}
      >
        EN
      </button>
    </div>
  );
}
